<template>
	<div class="white">
		<v-container
			v-if="record"
			:style="$vuetify.breakpoint.mdAndUp ? 'margin-bottom: 20px;' : 'padding-bottom: calc(90/728 * 100vw + 20px);'"
		>
			<v-row justify="center">
				<v-col
					cols="12"
					md="4"
					:style="$vuetify.breakpoint.mdAndUp ? 'position: sticky; top: 36px; height: max-content;' : ''"
				>
					<v-row>
						<v-col cols="12">
							<v-img
								contain
								:src="record.coverPic"
								class="grey lighten-3 mx-auto"
								:aspect-ratio="1"
								max-width="500"
								@click="showCover = true"
							>
								<template #placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-row>
								</template>

								<template #default>
									<v-img :src="record.coverPic" class="stretch" :aspect-ratio="1/1.4"></v-img>
								</template>
							</v-img>
						</v-col>
						<v-col cols="auto" class="ma-0 py-0 text-start">
							<span>
								<v-tooltip bottom>
									<template #activator=" {on} ">
										<span v-on="on">
											<v-icon right>mdi-calendar</v-icon>
											{{ record.publishDateWr }}
										</span>
									</template>
									<span v-if="record.publishDate">{{ record.publishDate.substring(0,10) }}</span>
								</v-tooltip>
							</span>
						</v-col>
						<v-spacer></v-spacer>
						<v-col v-if="configViewCount" cols="auto" class="ma-0 py-0 text-start">
							<span>{{ record.viewCount }}</span>
							<v-icon left>mdi-eye</v-icon>
						</v-col>
					</v-row>
					<v-divider></v-divider>
					<v-row>
						<v-col cols="12">
							<app-ad v-if="$vuetify.breakpoint.mdAndUp" key="middle" middle></app-ad>
							<app-ad v-else key="sticky" sticky-bottom></app-ad>
						</v-col>
					</v-row>
				</v-col>

				<v-col cols="12" md="8">
					<v-row class="text-center">
						<v-col cols="12" class="text-start">
							<h3>{{ record.title }}</h3>
						</v-col>

						<v-col v-if="showLimited" cols="12" class="text-start text-no-wrap overflow-x-auto">
							<v-chip
								v-for="spec in record.limitedCities"
								:key="spec.name"
								outlined
								color="secondary"
								class="mx-1 white--text"
							>
								{{ spec.name }}
							</v-chip>
							<v-chip
								v-if="record.diff > 0"
								outlined
								color="secondary"
								class="mx-1 white--text"
								@click="showLimited = false"
							>
								+ {{ record.diff }} فئات أخرى
							</v-chip>
						</v-col>
						<v-col v-else cols="12" class="text-start text-no-wrap overflow-x-auto">
							<v-chip
								v-for="spec in record.cities"
								:key="spec.name"
								outlined
								color="secondary"
								class="mx-1 white--text"
							>
								{{ spec.name }}
							</v-chip>
						</v-col>

						<v-col cols="12" class="text-start text-no-wrap overflow-x-auto">
							<v-chip
								v-if="record.status"
								:color="record.status.color"
								class="mx-1"
								outlined
								target="_blank"
							>
								{{ record.status.title }}
							</v-chip>

							<v-chip
								v-if="record.status.link"
								color="green"
								class="mx-1 white--text"
								:href="record.status.link"
								:outlined="!record.status.link"
								target="_blank"
							>
									<v-icon left>mdi-open-in-new</v-icon>
									للتقديم
							</v-chip>
						</v-col>

						<v-col cols="12" class="text-no-wrap">
							<v-row>
								<v-col class="shrink">
									<b>تاريخ البداية</b>
									<br />
									{{ record.startDate }}
								</v-col>
								<v-col v-if="record.endDate !='1994-11-23'" class="shrink">
									<b>تاريخ النهاية</b>
									<br />
									{{ record.endDate }}
								</v-col>
								<v-col v-else class="shrink">
									<b>تاريخ النهاية</b>
									<br />
									حين إكتمال العدد
								</v-col>
							</v-row>
						</v-col>

						<v-col v-if="record.note" cols="12" class="text-start">
							<!-- eslint-disable-next-line vue/no-v-html -->
							<p v-html="record.note"></p>
						</v-col>

						<v-col cols="12" class="text-start">
							<template v-if="record.email || record.phoneNumber">
								<b>معلومات التواصل:</b>
								<br />
								<a :href="'mailto:' + record.email">{{ record.email }}</a>
								<br />
								<a :href="'tel:+' + record.phoneNumber">{{ record.phoneNumber }}</a>
								<br />
							</template>
						</v-col>

						<v-col cols="12">
							<v-row class="text-start">
								<v-col v-if="record.attachments.length" cols="12">
									<b>المرفقات:</b>
									<br />
									<v-data-table
										mobile-breakpoint="0"
										:headers="galleryHeaders"
										:items="record.attachments"
										class="elevation-1"
										hide-default-footer
									>
										<template #[`item.placeName`]="{ item }">
											<a
												:href="item.locationLink"
												target="_blank"
												rel="noopener noreferrer"
											>{{ item.placeName }}</a>
										</template>

										<template #[`item.download`]="{ item }">
											<v-btn text icon color="primary" :href="item.path" target="_blank">
												<v-icon>mdi-file-download</v-icon>
											</v-btn>
										</template>
									</v-data-table>
								</v-col>

								<v-col v-if="false && record.communications.length" cols="12">
									<b>بيانات التواصل:</b>
									
									<v-row dense class="pt-2 pb-4">
										<v-col cols="12">
											<v-divider></v-divider>
										</v-col>
									</v-row>
									
									<app-communication-list :communications="record.communications"></app-communication-list>
								</v-col>

								<v-col v-if="false && record.photos.length" cols="12" class="text-start">
									<b>معرض الصور:</b>
									<br />
									<app-album :images="record.photos"></app-album>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>الوظيفة غير موجودة</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showCover">
			<v-container v-if="record" class="pa-0 fill-height">
				<v-img contain :src="record.coverPic" class="grey lighten-2" :style="getHeight">
					<v-row class="pa-0 white--text fill-height">
						<v-col class="text-left pa-0 pt-1 pl-4" cols="12">
							<v-btn
								:small="$vuetify.breakpoint.xsOnly"
								class="primary"
								rounded
								icon
								@click="showCover = false"
							>
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</v-col>
						<v-col class="text-center" cols="12" align-self="end">
							<a :href="record.coverPic" download target="_blank">
								<v-btn :small="$vuetify.breakpoint.xsOnly" class="primary" rounded>تحميل</v-btn>
							</a>
						</v-col>
					</v-row>
				</v-img>
			</v-container>
		</v-dialog>

		<app-social-sharing
			v-if="record"
			:id="$route.params.jobID"
			type="job"
			:content="{ url: record.url, title: record.title, description: record.rawNote }"
			:style="$vuetify.breakpoint.mdAndUp ? '' : 'margin-bottom: calc(90/728 * 100vw);'"
		></app-social-sharing>
	</div>
</template>

<script>
import client from "@/client";
import { textToLink } from "@/utils/textToLink";

export default {
	components: {
		"app-ad": require("@/components/general/AppAd").default,
		"app-album": require("@/components/general/AppAlbum").default,
		"app-communication-list": () => import(/* webpackChunkName: "app-communication-list" */ "@/components/content/AppCommunicationList"),
		"app-social-sharing": require("@/components/general/AppSocialSharing")
			.default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			record: null,
			showLimited: true,
			infoHeaders: [
				{ text: "المدينة", value: "cityName" },
				{ text: "المكان", value: "placeName" },
				{ text: "وصف المكان", value: "locationDetails" },
				{ text: "تاريخ البدء", value: "startDate" },
				{ text: "تاريخ الإنتهاء", value: "endDate" },
				{ text: "وقت البدء", value: "startTime" },
				{ text: "وقت الانتهاء", value: "endTime" },
				{ text: "الوصف", value: "description" }
			],

			galleryHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "تحميل", value: "download" }
			],
			missingRecord: false,
			showCover: false
		};
	},
	computed: {
		getHeight() {
			var height = window.innerHeight - 100;
			return "height: " + height + "px;";
		},
		configViewCount() {
			return this.$store.state.viewCount;
		}
	},
	mounted() {
		this.getRecord();
	},
	methods: {
		getRecord() {
			client
				.get("/api/jobs/show/" + this.$route.params.jobID, {})
				.then(response => {
					console.log(response);
					var newData = response.data.data[0];

					// newData.photos = newData.attachments
					// 	.filter(att => {
					// 		var type = att.fileType.toLocaleLowerCase();
					// 		const allowed = ["jpeg", "jpg", "png"];
					// 		if (allowed.includes(type)) {
					// 			return true;
					// 		}
					// 	})
					// 	.map(att => att.path);

					// newData.attachments = newData.attachments.map(att => {
					// 	if (att.description == "null") {
					// 		att.description = null;
					// 	}

					// 	return att;
					// });

					var today = new Date().toISOString().substr(0, 10);

					var date = "";

					if (newData.startDate > today) {
						date = newData.startDate
							.substr(5, 5)
							.replace("-", "/");
						newData.status = {
							title: "يبدأ التسجيل " + date,
							color: "amber darken-2"
						};
					} else if (newData.endDate =='1994-11-23') {
						newData.status = {
							title: "ينتهي التسجيل بإكتمال العدد",
							color: "primary",
							link: newData.link
						};
					} else if (newData.endDate >= today) {
						date = newData.endDate
							.substr(5, 5)
							.replace("-", "/");
						newData.status = {
							title: "ينتهي التسجيل " + date,
							color: "primary",
							link: newData.link
						};
					} else {
						newData.status = {
							title: "انتهى التسجيل",
							color: "error"
						};
					}

					newData.url = location.href;

					var limit = 3;
					newData.limitedCities = newData.cities.slice(0, limit);
					newData.diff = newData.cities.length - limit;

					if (newData.note) {
						newData.rawNote = newData.note;
						newData.note = textToLink(newData.note.replace(/&nbsp;/ig, " "));
					}
					if (newData.email == "null") {
						newData.email = null
					}
					if (newData.phoneNumber == "null") {
						newData.phoneNumber = null
					}

					this.record = newData;
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		}
	}
};
</script>

<style scoped>
.v-dialog__content ::v-deep .v-dialog {
	width: auto;
}
</style>